/** @format */

import { FunctionComponent as FC, useContext, useState } from 'react';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import styled, { ThemeContext } from 'styled-components';
import { Error } from './Error';
import { FormControl } from './FormControl';

export const TextArea: FC<Props<FieldValues>> = ({
  name,
  register,
  errors,
  required,
  label,
  variant = 'light',
  type,
  rows,
  onChange,
  onBlur,
}) => {
  const theme = useContext(ThemeContext);
  const [value, setValue] = useState<string>('');

  const onTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    onChange && onChange(e);
    onBlur && onBlur(e);
  };

  return (
    <>
      <FormControl $filled={value !== ''} $variant={variant}>
        <label htmlFor={name} dangerouslySetInnerHTML={{ __html: label }} />
        <StyledTextArea
          id={name}
          {...register(name, { required, onChange: e => onTextAreaChange(e), onBlur: e => onTextAreaChange(e) })}
          aria-invalid={errors[name] ? 'true' : 'false'}
          rows={rows ? rows : 3}
        />
      </FormControl>
      {errors[name] && <Error message={String(errors[name]?.message) ?? 'error'} />}
    </>
  );
};

type Props<T extends FieldValues> = {
  name: keyof T;
  label: string;
  variant?: 'light' | 'dark';
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  required?: boolean | string;
  type?: React.HTMLInputTypeAttribute;
  rows?: number;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: React.ChangeEventHandler<HTMLTextAreaElement>;
};

const StyledTextArea = styled.textarea`
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  /* &[type='radio'] {
    width: 1rem;
    height: 1rem;
    accent-color: ${({ theme }) => theme.color.pink};
  } */

  &[type='checkbox'] {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    accent-color: ${({ theme }) => theme.color.teal.dark};
  }
`;
